<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    hide-header
    :size="'lg'"
    :modal-id="'flashdeal-edit-privilege'"
    @hidden="$bvModal.hide('flashdeal-edit-privilege')"
    @show="() => {}"
  >
    <b-form @submit.prevent="$emit('editPrivilege', privilegeObj)">
      <div class="position-relative">
        <div class="row mb-3">
          <div class="col-12 p-0">
            <div class="d-flex information-header">
              <div class="mr-auto">
                <div>Edit : {{ privilegeObj.privilegeName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-wrp mx-3">
          <div class="container">
            <div class="row">
              <div class="col-12 p-0">
                <div class="detail-bg-wrp p-1">
                  <div class="d-flex">
                    <div class="w-40 m-auto">
                      <div class="text-center">
                        <img
                          :src="privilegeObj.privilegeImage || DefaultImg"
                          class="w-80"
                        />
                      </div>
                    </div>
                    <div class="w-60">
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Status
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.status }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Reference
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.reference }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Privilege Name
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.privilegeName }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Privilege Type
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ PRIVILEGE_TYPE.getTypeDesc(privilegeObj.privilegeType) }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Point
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.point }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Valid From
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.validFrom }}
                        </div>
                      </div>
                      <div class="d-flex">
                        <div class="text-black font-medium-5 w-40">
                          Valid Through
                        </div>
                        <div class="font-medium-5 w-60">
                          {{ privilegeObj.validThrough }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 mb-2">
              <div class="col-12">
                <label for="new-point" class="font-medium-5">
                  New Point
                </label>
                <b-form-input
                  id="new-point"
                  placeholder="ระบุ"
                  required
                  class="textbox-input"
                  type="number"
                  autocomplete="off"
                  v-model="privilegeObj.newPoint"
                />
              </div>
            </div>
            <!-- <div class="row mb-2">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-12">
                    <label class="font-medium-5">Issue</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-input-group
                      class="custom-append-input"
                      append="Overall"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Day"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Customer"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Customer per Day"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-12">
                    <label class="font-medium-5">Redeem</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-input-group
                      class="custom-append-input"
                      append="Overall"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Day"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Customer"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                  <div class="col-12 mt-1">
                    <b-input-group
                      class="custom-append-input"
                      append="per Customer per Day"
                    >
                      <b-form-input
                        class="textbox-input"
                        type="number"
                        autocomplete="off"
                      />
                    </b-input-group>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="modal-btn-wrp mt-2 mb-2">
              <div class="d-flex justify-content-center">
                <cancel-button
                  class="mr-1"
                  :btn-label="'Cancel'"
                  @click.native="$emit('onCloseEditModal')"
                />
                <save-button class="ml-1" type="submit" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>

import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import { PRIVILEGE_TYPE } from "@/configs/privilege/privilege";

export default {
  components: {},
  props: { privilegeObj: [Object, Array] },
  setup(props) {
    return {
      DefaultImg,
      PRIVILEGE_TYPE
    };
  },
};
</script>

<style>
#flashdeal-edit-privilege .modal-content {
  border-radius: 1.6rem;
}
</style>

<style scoped>
#flashdeal-edit-privilege .privilege-img {
  height: 35%;
  border-bottom: 1px solid #e6e6e5;
  border-radius: 0.8rem;
}

#flashdeal-edit-privilege .privilege-text-wrp {
  height: 55%;
}

#flashdeal-edit-privilege .privilege-text-content {
  height: 45px;
  max-height: 45px;
  overflow-y: auto;
}

#flashdeal-edit-privilege .mtl-auto {
  margin: auto 0 auto 0;
}

#flashdeal-edit-privilege .btn-custom {
  border: transparent !important;
  background-color: transparent !important;
  padding: 0;
}

#flashdeal-edit-privilege .arrow-icon-size {
  width: 18px;
  height: 18px;
}

#flashdeal-edit-privilege .point-wrp {
  border: 1px solid #e6e6e5;
  border-radius: 5px;
  padding: 0 0.5rem;
}

#flashdeal-edit-privilege .point-wrp-bg {
  background-color: #e6e6e5;
}

#flashdeal-edit-privilege .detail-bg-wrp {
  background-color: #f4f4f4;
  border-radius: 1.6rem;
}

#flashdeal-edit-privilege .custom-append-input.input-group {
  border: 1px solid #d8d6de;
  border-radius: 0.8rem;
}

#flashdeal-edit-privilege .custom-append-input.input-group > input {
  border: none;
}

#flashdeal-edit-privilege
  .custom-append-input
  .input-group-append
  .input-group-text {
  border: none;
  background: transparent;
  font-size: 1.5rem;
}

#flashdeal-edit-privilege
  .custom-append-input.input-group:not(.bootstrap-touchspin):focus-within {
  border-color: var(--primary);
}

#flashdeal-edit-privilege .modal-dialog {
  align-items: baseline !important;
}

#flashdeal-edit-privilege .modal-header {
  display: none;
}

#flashdeal-edit-privilege .information-header {
  font-size: 2.4rem !important;
  width: 100%;
  border-bottom: 1px solid #ececec;
  padding: 5px 40px 10px;
  color: #000080;
}

#flashdeal-edit-privilege .form-control.is-valid {
  border-color: #d8d6de;
  background-image: unset;
  background-repeat: unset;
  background-size: unset;
}
</style>
